import { useState, useEffect } from "react";
import { FilterDto } from "../components/filter";
import {
  EventScheduleCountResponse,
  EventScheduleResponse,
  getEventScheduleAttendee,
  getEventScheduleByDate,
  getEventScheduleByMonth,
  getEventScheduleCount,
  getEventSchedulePub,
} from "../../../../api/event-schedule";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { fornatDateBydayjs } from "../utils/calender";
dayjs.extend(utc);
dayjs.extend(timezone);

const KST = "Asia/Seoul";

export const attendeeLabel = {
  id: -1,
  name: "크리에이터",
};
export const pubLabel = {
  id: -1,
  name: "매장",
};

export interface DaysDto {
  dayList: { day: number; week: string; count: number }[];
  daysEmpty: number[];
}
export const useSchedule = () => {
  const [date, setDate] = useState<string>("");
  const currentDate = new Date();
  const [year, setYear] = useState<number>(currentDate.getFullYear());
  const [month, setMonth] = useState<number>(currentDate.getMonth() + 1);
  const [list, setList] = useState<EventScheduleResponse[]>([]);
  const [countList, setCountList] = useState<EventScheduleCountResponse[]>([]);
  const [attendeeList, setAttendeeList] = useState<FilterDto[]>([]);
  const [pubList, setPubList] = useState<FilterDto[]>([]);
  const [selectedAttendee, setSelectedAttendee] =
    useState<FilterDto>(attendeeLabel);
  const [selectedPub, setSelectedPub] = useState<FilterDto>(pubLabel);

  ///////////////////////// 스케줄 리스트 /////////////////////////
  const getData = async () => {
    let response: EventScheduleResponse[] = [];
    if (!date) {
      response = await getEventScheduleByMonth(
        year,
        month,
        selectedPub?.id,
        selectedAttendee?.id
      );
    } else {
      response = await getEventScheduleByDate(
        date,
        selectedPub?.id,
        selectedAttendee?.id
      );
    }
    setList(response);
  };

  useEffect(() => {
    getData();
  }, [year, month, selectedAttendee, selectedPub, date]);

  ///////////////////////// 일별 방문자 수 /////////////////////////
  const getCountList = async (currentMonthLabel?: string) => {
    let list: EventScheduleCountResponse[] = [];
    if (currentMonthLabel) {
      const [year, month, _] = currentMonthLabel.split("-");
      list = await getEventScheduleCount(
        +year,
        +month,
        selectedPub.id,
        selectedAttendee.id
      );
    } else {
      list = await getEventScheduleCount(
        year,
        month,
        selectedPub.id,
        selectedAttendee.id
      );
    }
    const result = list.map((i) => {
      return {
        ...i,
        date: fornatDateBydayjs(i.date),
      };
    });
    setCountList(result);
  };

  useEffect(() => {
    getCountList();
  }, [selectedAttendee, selectedPub, year, month]);

  ///////////////////////// 일별 방문자 수 포함한 날짜 리스트 /////////////////////////

  const renderDays = (currentMonthLabel: string) => {
    const current = dayjs.tz(currentMonthLabel, KST);
    const year = current.year();
    const month = current.month() + 1; // 0-based

    const firstDay = dayjs.tz(`${year}-${month}-01`, "YYYY-MM-DD", KST).day(); // 요일
    const lastDate = current.daysInMonth(); // 해당 월의 마지막 날짜

    const dayList = Array.from({ length: lastDate }, (_, i) => {
      const dateObj = dayjs.tz(
        `${year}-${String(month).padStart(2, "0")}-${String(i + 1).padStart(
          2,
          "0"
        )}`,
        "YYYY-MM-DD",
        KST
      );
      const week = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][
        dateObj.day()
      ];
      const day = (i + 1).toString().padStart(2, "0");
      const count = isCount(dateObj);
      return { day: +day, week, count };
    });

    const daysEmpty = Array.from({ length: firstDay }, () => 0);

    return { dayList, daysEmpty };
  };

  const isCount = (dateObj: dayjs.Dayjs) => {
    const formatted = dateObj.format("YYYY-MM-DD"); // KST 기준으로 포맷
    const countItem = countList.find((item) => item.date === formatted);
    return countItem ? countItem.count : 0;
  };

  ///////////////////////// 월별 펍, 크리에이터 필터 리스트 /////////////////////////
  const getFilterList = async () => {
    const attendeeResponse = await getEventScheduleAttendee(year, month);
    const pubResponse = await getEventSchedulePub(year, month);
    const attendee = attendeeResponse.map((item) => {
      return { id: item.id, name: item.name };
    });
    const pub = pubResponse.map((item) => {
      return { id: item.id, name: item.pubName ?? "" };
    });

    const attendeeList = [];
    const pubList = [];

    attendeeList.push(attendeeLabel);
    attendeeList.push(...attendee);
    setAttendeeList(attendeeList);
    setSelectedAttendee(attendeeLabel);

    pubList.push(pubLabel);
    pubList.push(...pub);
    setPubList(pubList);
    setSelectedPub(pubLabel);
  };

  useEffect(() => {
    getFilterList();
  }, [year, month]);

  return {
    list,
    countList,
    renderDays,
    attendeeList,
    pubList,
    selectedPub,
    setSelectedPub,
    selectedAttendee,
    setSelectedAttendee,
    date,
    setDate,
    year,
    setYear,
    month,
    setMonth,
    getCountList,
  };
};
